// extracted by mini-css-extract-plugin
export default {"layout":"QuestionTile_layout__0YU3B","question":"QuestionTile_question__5DAtS"};